// In the BP this should be empty. Enter your custom JS here
const gameHelpers = require('../game/helpers').default;

document.addEventListener("DOMContentLoaded", function() {
    $('#already_won_modal').modal('show');

    if (window.location.search === '?won') {
        gameHelpers.fireConfetti('side', 1, '#122956, #41caff, #ff070f, #ffffff');
        window.history.replaceState({}, document.title, window.location.pathname);
    }
});
